module.exports = __webpack_public_path__ + "static/media/rc5.68fef6e3.jpg";